import { request } from '../config/axios-utils';

export const getCurrentOrganization = async id => {
    const { data } = await request({
        url: `/users/current-organization/${id}`,
        method: 'post'
    });
    return data;
};

export const getUserProfile = async () => {
    const { data } = await request({ url: '/users', method: 'get' });
    return data;
};

export const postUserProfile = async values => {
    const { data } = await request({
        url: '/users',
        method: 'put',
        data: values
    });
    return data;
};
